//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets HL7 messages.
 * @param id (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param direction (optional) 
 * @param type (optional) 
 * @param status (optional) 
 * @param search (optional) 
 * @param searchByError (optional) 
 * @param patientId (optional) 
 * @param limitContentLength (optional) Content of HL7 could be quite big (e.g. if it embeds the base64 file).
So for showing it to a user in UI it'd be good to limit the length
 * @param removeContent (optional) Do not return Content at all
(could be used in Patient pages where we show the status depending on the presence of the message, ignoring the content)
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function getMessages(id?: number | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, direction?: Types.HL7MessageDirection | null | undefined, type?: Types.HL7MessageType | null | undefined, status?: Types.GDTMessageStatus | null | undefined, search?: string | null | undefined, searchByError?: string | null | undefined, patientId?: number | null | undefined, limitContentLength?: boolean | undefined, removeContent?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PageableListDtoOfHL7MessageDto> {
    let url_ = getBaseUrl() + "/api/hl7/messages?";
    if (id !== undefined && id !== null)
        url_ += "Id=" + encodeURIComponent("" + id) + "&";
    if (from !== undefined && from !== null)
        url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
    if (to !== undefined && to !== null)
        url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
    if (direction !== undefined && direction !== null)
        url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
    if (type !== undefined && type !== null)
        url_ += "Type=" + encodeURIComponent("" + type) + "&";
    if (status !== undefined && status !== null)
        url_ += "Status=" + encodeURIComponent("" + status) + "&";
    if (search !== undefined && search !== null)
        url_ += "Search=" + encodeURIComponent("" + search) + "&";
    if (searchByError !== undefined && searchByError !== null)
        url_ += "SearchByError=" + encodeURIComponent("" + searchByError) + "&";
    if (patientId !== undefined && patientId !== null)
        url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
    if (limitContentLength === null)
        throw new Error("The parameter 'limitContentLength' cannot be null.");
    else if (limitContentLength !== undefined)
        url_ += "LimitContentLength=" + encodeURIComponent("" + limitContentLength) + "&";
    if (removeContent === null)
        throw new Error("The parameter 'removeContent' cannot be null.");
    else if (removeContent !== undefined)
        url_ += "RemoveContent=" + encodeURIComponent("" + removeContent) + "&";
    if (pagination_Offset === null)
        throw new Error("The parameter 'pagination_Offset' cannot be null.");
    else if (pagination_Offset !== undefined)
        url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
    if (pagination_Limit === null)
        throw new Error("The parameter 'pagination_Limit' cannot be null.");
    else if (pagination_Limit !== undefined)
        url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
    if (sorting_SortField !== undefined && sorting_SortField !== null)
        url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
    if (sorting_SortDirection === null)
        throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
    else if (sorting_SortDirection !== undefined)
        url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
    if (additionalSorting !== undefined && additionalSorting !== null)
        additionalSorting && additionalSorting.forEach((item, index) => {
            for (let attr in item)
    			if (item.hasOwnProperty(attr)) {
    				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
    			}
        });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetMessages,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetMessages?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetMessages(_response);
    });
}

function processGetMessages(response: AxiosResponse): Promise<Types.PageableListDtoOfHL7MessageDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPageableListDtoOfHL7MessageDto(resultData200);
        return Promise.resolve<Types.PageableListDtoOfHL7MessageDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PageableListDtoOfHL7MessageDto>(null as any);
}

/**
 * Starts re-processing of messages that fit the filter.
 * @param id (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param direction (optional) 
 * @param type (optional) 
 * @param status (optional) 
 * @param search (optional) 
 * @param searchByError (optional) 
 * @param patientId (optional) 
 * @param limitContentLength (optional) Content of HL7 could be quite big (e.g. if it embeds the base64 file).
So for showing it to a user in UI it'd be good to limit the length
 * @param removeContent (optional) Do not return Content at all
(could be used in Patient pages where we show the status depending on the presence of the message, ignoring the content)
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 * @param useFilters (optional) 
 */
export function reprocessMessage(id?: number | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, direction?: Types.HL7MessageDirection | null | undefined, type?: Types.HL7MessageType | null | undefined, status?: Types.GDTMessageStatus | null | undefined, search?: string | null | undefined, searchByError?: string | null | undefined, patientId?: number | null | undefined, limitContentLength?: boolean | undefined, removeContent?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, useFilters?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/hl7/messages/process?";
    if (id !== undefined && id !== null)
        url_ += "Id=" + encodeURIComponent("" + id) + "&";
    if (from !== undefined && from !== null)
        url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
    if (to !== undefined && to !== null)
        url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
    if (direction !== undefined && direction !== null)
        url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
    if (type !== undefined && type !== null)
        url_ += "Type=" + encodeURIComponent("" + type) + "&";
    if (status !== undefined && status !== null)
        url_ += "Status=" + encodeURIComponent("" + status) + "&";
    if (search !== undefined && search !== null)
        url_ += "Search=" + encodeURIComponent("" + search) + "&";
    if (searchByError !== undefined && searchByError !== null)
        url_ += "SearchByError=" + encodeURIComponent("" + searchByError) + "&";
    if (patientId !== undefined && patientId !== null)
        url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
    if (limitContentLength === null)
        throw new Error("The parameter 'limitContentLength' cannot be null.");
    else if (limitContentLength !== undefined)
        url_ += "LimitContentLength=" + encodeURIComponent("" + limitContentLength) + "&";
    if (removeContent === null)
        throw new Error("The parameter 'removeContent' cannot be null.");
    else if (removeContent !== undefined)
        url_ += "RemoveContent=" + encodeURIComponent("" + removeContent) + "&";
    if (pagination_Offset === null)
        throw new Error("The parameter 'pagination_Offset' cannot be null.");
    else if (pagination_Offset !== undefined)
        url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
    if (pagination_Limit === null)
        throw new Error("The parameter 'pagination_Limit' cannot be null.");
    else if (pagination_Limit !== undefined)
        url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
    if (sorting_SortField !== undefined && sorting_SortField !== null)
        url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
    if (sorting_SortDirection === null)
        throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
    else if (sorting_SortDirection !== undefined)
        url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
    if (additionalSorting !== undefined && additionalSorting !== null)
        additionalSorting && additionalSorting.forEach((item, index) => {
            for (let attr in item)
    			if (item.hasOwnProperty(attr)) {
    				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
    			}
        });
    if (useFilters === null)
        throw new Error("The parameter 'useFilters' cannot be null.");
    else if (useFilters !== undefined)
        url_ += "useFilters=" + encodeURIComponent("" + useFilters) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigReprocessMessage,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigReprocessMessage?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processReprocessMessage(_response);
    });
}

function processReprocessMessage(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Removes GDT message.
 * @param id The message id.
 */
export function remove(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/hl7/messages/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemove,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigRemove?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemove(_response);
    });
}

function processRemove(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetMessages: Partial<AxiosRequestConfig> | null;
export function getGetMessagesRequestConfig() {
  return _requestConfigGetMessages;
}
export function setGetMessagesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetMessages = value;
}
export function patchGetMessagesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetMessages = patch(_requestConfigGetMessages ?? {});
}

let _requestConfigReprocessMessage: Partial<AxiosRequestConfig> | null;
export function getReprocessMessageRequestConfig() {
  return _requestConfigReprocessMessage;
}
export function setReprocessMessageRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigReprocessMessage = value;
}
export function patchReprocessMessageRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigReprocessMessage = patch(_requestConfigReprocessMessage ?? {});
}

let _requestConfigRemove: Partial<AxiosRequestConfig> | null;
export function getRemoveRequestConfig() {
  return _requestConfigRemove;
}
export function setRemoveRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemove = value;
}
export function patchRemoveRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemove = patch(_requestConfigRemove ?? {});
}